module.exports = __webpack_public_path__ + "static/media/key_color.ed9edcf2.svg";